var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabelWidgetLt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 45,
    viewBox: "0 0 140 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 13884",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h140v45H0z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1v43h138V1H1M0 0h140v45H0V0z",
    style: {
      fill: "#333",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Enter Label",
    transform: "translate(16 28)",
    style: {
      fill: "#333",
      fontSize: 14,
      fontFamily: "Roboto-Medium,Roboto",
      fontWeight: 500
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u012Eveskite etiket\u0119"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelWidgetLt);
export default __webpack_public_path__ + "static/media/label-widget-lt.2b970cb7db672ecfe82064fcdad0759b.svg";
export { ForwardRef as ReactComponent };